import { Menu, MenuItem } from "@mui/material";
import { OLButton } from "OLButton";
import { ReactComponent as DotsVerticalIcon } from "components/Icons/dots-vertical.svg";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useContextMenu } from "hooks/contextMenu";
import { useMessage } from "hooks/intl";
import { useStyles } from "./styles";

interface Props {
  isSelected: boolean;
  idx: number;
  name: string;
  setActiveTranslation: (idx: number) => void;
  onDelete: () => void;
  "data-test-id": string;
}

export const TranslationTab = ({
  isSelected,
  idx,
  name,
  setActiveTranslation,
  onDelete,
  "data-test-id": dataTestId,
}: Props) => {
  const { message } = useMessage();
  const classes = useStyles({ isSelected });
  const contextMenu = useContextMenu();

  const maxNameLength = 12;
  const isNameTooLong = name && name.length > maxNameLength;

  return (
    <>
      <OLButton
        id={`tab-${idx}`}
        onClick={() => setActiveTranslation(idx)}
        variant={isSelected ? "contained" : "outlined"}
        sx={{
          borderColor: "transparent",
        }}
        className={classes.btn}
        size="small"
        data-test-id={dataTestId}
      >
        <span>
          <Tooltip text={isNameTooLong ? name : ""}>
            <span>
              {isNameTooLong ? `${name.substring(0, maxNameLength)}...` : name}
            </span>
          </Tooltip>
        </span>
        <div className={classes.contextMenu}>
          <DotsVerticalIcon
            fill="white"
            onClick={(e) => {
              contextMenu.handleMenuOpen(e);
            }}
          />
        </div>
      </OLButton>
      <Menu
        classes={{ paper: classes.tabMenu }}
        anchorEl={contextMenu.anchor}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        onClose={contextMenu.handleMenuClose}
        open={contextMenu.isMenuOpen}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
      >
        <MenuItem
          className={classes.tabMenuItem}
          onClick={() => {
            onDelete();
            contextMenu.handleMenuClose();
          }}
        >
          {message({ id: "removeTranslation" })}
        </MenuItem>
      </Menu>
    </>
  );
};
